import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class MissingCourseResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.courses = [];
        this.errors = [];
    }
    pk() {
        return "all";
    }
    static url() {
        return this.urlRoot;
    }
}
MissingCourseResource.urlRoot = apiResourceUrl("user/courses/incomplete");
//# sourceMappingURL=MissingCourseResource.js.map